import { sessionApiClient } from "@planningcenter/cc-api-client"

async function fetchFlags() {
  console.debug("Loading giving flags")
  const response = await sessionApiClient.get("/giving/v2/flags", {
    "fields[Flag]": "monorepo_donation_form,monorepo_my_giving,memo_line",
  })
  return response.data.attributes
}

export function fetchFlagsQuery() {
  return {
    queryKey: ["Giving", "Flags"],
    queryFn: fetchFlags,
    staleTime: Infinity,
  }
}
